<template>
<div class="chapter">
<div class="inner_page">
<h1 class="FMBM-head">DEDICATION</h1>
<p class="dedication">This book is dedicated to my loving family,</p>
<p class="dedication1">Troy, Nikai, and Troy II</p>
<p class="dedication">-and-</p>
<p class="dedication">To my grandparents,</p>
<p class="dedication1">Catherine Eggleston, and Joe and Arrie McCullar.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?31f79dae